export default {
  "goals": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["goals"])},
  "last_week_completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last week completed"])},
  "toggle_dark_theme": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toggle Dark Theme"])},
  "happy_new_year": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Happy new year"])},
  "so_far_done": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["So far done"])},
  "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["week"])},
  "weekly_goals": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weekly goals"])}
}